import { render, staticRenderFns } from "./SelectAddGood.vue?vue&type=template&id=01d264de&scoped=true"
import script from "./SelectAddGood.vue?vue&type=script&lang=js"
export * from "./SelectAddGood.vue?vue&type=script&lang=js"
import style0 from "./SelectAddGood.vue?vue&type=style&index=0&id=01d264de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d264de",
  null
  
)

export default component.exports